import { Box } from '@mui/material';
import { CustomSpinner } from 'components/spinner/spinner.styles';
import { Helmet } from 'react-helmet';

const IncWaitPage = ({ helmetTitle, children }) => {
  return (
    <Box
      display="flex"
      width="100%"
      flex="1"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      data-testid="CheckoutStatus.Box"
    >
      <Helmet title={helmetTitle} />
      <Box mb={1}>
        <CustomSpinner />
      </Box>
      {children}
    </Box>
  );
};

export default IncWaitPage;
